/* eslint-disable array-callback-return */
import { Row, Col } from "antd";
import React, { useRef } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import { Image, Dropdown, Menu } from "antd";
import { NavLink, Link } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import clsx from "clsx";
import { downloadImageCommon, exportChatFile, currencyFormat, currencyFormatInt } from "../../../../helpers/utilities";
import { Swiper, SwiperSlide } from "swiper/react";
import useMediaQuery from '@mui/material/useMediaQuery';
import { AESEncrypt } from "../../../../helpers/Crypto";

export const OverDue = (props) => {
    const { title, salesDashboardDetails, type } = props;
    const classes = customStyles();
    const overdue = useRef(null);
    const mobileDevice = useMediaQuery('(min-width:1300px)');

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(overdue.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [
            ['Total No. of Invoices Over Due', 'Oldest Overdue Amount', 'Largest Overdue Amount'],
            [salesDashboardDetails?.total_invoices, salesDashboardDetails?.oldest_overdue?.invoiceAmount, salesDashboardDetails?.largest_overdue?.total],
        ];

        newHead[newHead.length + 1] = ['Due Date Greater than 0 - 15 days'];
        newHead[newHead.length] = ['Name', 'Invoice Amount', 'Balance Due'];
        salesDashboardDetails['over_due_0_15'].map((data, i) => {
            newHead[newHead.length] = [data?.name, data?.invoices, data?.balance];
        });

        newHead[newHead.length + 1] = ['Due Date Greater than 15 - 30 days'];
        newHead[newHead.length] = ['Name', 'Invoice Amount', 'Balance Due'];
        salesDashboardDetails['over_due_15_30'].map((data, i) => {
            newHead[newHead.length] = [data?.name, data?.invoices, data?.balance];
        });

        newHead[newHead.length + 1] = ['Due Date Greater than 30 - 45 days'];
        newHead[newHead.length] = ['Name', 'Invoice Amount', 'Balance Due'];
        salesDashboardDetails['over_due_30_45'].map((data, i) => {
            newHead[newHead.length] = [data?.name, data?.invoices, data?.balance];
        });
        exportChatFile(title, newHead);
    }
    return (
        <div ref={overdue} className={classes.totalChartDiv}>
            <div className={clsx(classes.monthlyDivTitle, classes.bold)}><span>{title}</span>
                <span className={classes.hamburgerMenu}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
            </div>
            <div className={clsx(classes.chartOverDue)}>
                <Row gutter={5} type="flex">
                    <Col span={12}>
                        <Link to={`${type}/transactions/invoice-history/overDue`} className={clsx(classes.totalInvoiceDue, classes.bg_green)}>
                            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <span>Total Amount</span>
                                <span>|</span>
                                <span>No. of Invoice</span>
                            </div> <div style={{ opacity: 0 }} className={classes.largestOverdueName}>{salesDashboardDetails?.largest_overdue?.name}
                            </div>
                            <div className={clsx(classes.daysRowTitle, classes.totalInvoicesAmount, classes.bold)}>
                                {/* <div className={classes.largestOverdueName}>{"Overdue"}
                                </div> */}
                                ₹ {currencyFormatInt(salesDashboardDetails?.total_invoices_amount || 0)}
                                <span>{salesDashboardDetails?.total_invoices}</span></div>
                        </Link>
                    </Col>
                    {/* <Col span={8}>
                            <div className={clsx(classes.totalInvoiceDue, classes.bg_blue, classes.textAlignRight)}>
                                Oldest Overdue Amount
                                <div className={clsx(classes.totalInvoicesAmount, classes.bold)}>₹ {currencyFormatInt(salesDashboardDetails?.oldest_overdue?.invoiceAmount || 0)}</div>
                            </div>
                        </Col> */}
                    <Col span={12}>
                        <Link to={`${type}/transactions/${AESEncrypt(salesDashboardDetails?.largest_overdue?.id)}/invoice-history`} className={clsx(classes.totalInvoiceDue, classes.bg_yellow)}>
                            <span>Largest Overdue Amount<br /> <div className={classes.largestOverdueName}>{salesDashboardDetails?.largest_overdue?.name}
                            </div></span>
                            <div className={clsx(classes.daysRowTitle, classes.totalInvoicesAmount, classes.bold)}>
                                ₹ {currencyFormatInt(salesDashboardDetails?.largest_overdue?.balance || 0)}</div>
                        </Link>
                    </Col>
                </Row>
            </div>
            <div className={clsx(classes.overFolwBigContent, classes.scrollBarLight, { [classes.overDueLangth]: salesDashboardDetails && salesDashboardDetails['over_due_0_15']?.length === 0 })} style={{ height: "calc(100% - 135px)" }}>
                <div className={clsx(classes.chartOverDueContent)}>
                    <div className={clsx(classes.bold, classes.dueDate)}><span>Due Date Greater than</span>
                        <span className={clsx(classes.bold)}> 0 - 15 days</span>
                    </div>
                    <Swiper
                        id="swiper-over_due_zero_15"
                        slidesPerView={mobileDevice ? 2 : 1.65}
                        spaceBetween={mobileDevice ? 10 : 0}
                        slidesPerGroup={mobileDevice ? 2 : 1.65}
                        autoplay={{
                            delay: 5000,
                            pauseOnMouseEnter: true
                        }}
                        loop
                        onReachEnd={() => {
                        }}
                        pagination={false}>
                        {
                            salesDashboardDetails && salesDashboardDetails['over_due_0_15']?.length > 0 ? salesDashboardDetails['over_due_0_15']?.map((data, i) => (
                                <SwiperSlide key={`over_due_0_15-${i}`} style={{ listStyle: "none" }}>
                                    <div className={classes.daysRow} key={i}>
                                        <Link to={`/${type}/transactions/${AESEncrypt(data?.id)}/invoice-history`} className={clsx(classes.daysRowTitle, classes.bold, classes.overDuedaysRowTitle)}><span className={clsx(classes.bg_blue_light)}><span>{i + 1}</span></span>{data.name}</Link>
                                        <div className={clsx(classes.daysRowContent, classes.bg_blue_light)}>
                                            <div className={classes.daysRowContentInner}>
                                                <div className={classes.daysRowContentTitle}>No. of Invoices</div><div className={clsx(classes.daysRowText, classes.bold)}>{data.invoices}</div>
                                            </div>
                                            <div className={clsx(classes.daysRowContentInner, classes.daysRowContentInner, classes.textAlignRight)}>
                                                <div className={classes.daysRowContentTitle}>Balance (₹)</div><div className={clsx(classes.daysRowText, classes.bold)}>{currencyFormat(data.balance)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )) : 'No Overdues'
                        }
                    </Swiper>
                </div>
                <div className={clsx(classes.chartOverDueContent)}>
                    <div className={clsx(classes.bold, classes.dueDate)}><span>Due Date Greater than</span>
                        <span className={clsx(classes.bold)}> 16 - 30 days</span></div>
                    <Swiper
                        id="swiper-over_due_fifteen_30"
                        slidesPerView={mobileDevice ? 2 : 1}
                        spaceBetween={mobileDevice ? 10 : 0}
                        slidesPerGroup={mobileDevice ? 2 : 1}
                        autoplay={{
                            delay: 5000,
                            pauseOnMouseEnter: true
                        }}
                        loop
                        onReachEnd={() => {
                        }}
                        pagination={false}>
                        {
                            salesDashboardDetails && salesDashboardDetails['over_due_15_30']?.length > 0 ? salesDashboardDetails['over_due_15_30']?.map((data, i) => (
                                <SwiperSlide key={`over_due_15_30-${i}`} style={{ listStyle: "none" }}>
                                    <div className={classes.daysRow} key={i}>
                                        <Link to={`/${type}/transactions/${AESEncrypt(data?.id)}/invoice-history`} className={clsx(classes.daysRowTitle, classes.bold, classes.overDuedaysRowTitle)}><span className={clsx(classes.bg_yellow_light)}><span>{i + 1}</span></span>{data.name}</Link>
                                        <div className={clsx(classes.daysRowContent, classes.bg_yellow_light)}>
                                            <div className={classes.daysRowContentInner}>
                                                <div className={classes.daysRowContentTitle}>No. of Invoices</div><div className={clsx(classes.daysRowText, classes.bold)}>{data.invoices}</div>
                                            </div>
                                            <div className={clsx(classes.daysRowContentInner, classes.daysRowContentInner, classes.textAlignRight)}>
                                                <div className={classes.daysRowContentTitle}>Balance (₹)</div><div className={clsx(classes.daysRowText, classes.bold)}>{currencyFormat(data.balance)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )) : 'No Overdues'
                        }
                    </Swiper>
                </div>
                <div className={clsx(classes.chartOverDueContent)}>
                    <div className={clsx(classes.bold, classes.dueDate)}><span>Due Date Greater than</span>
                        <span className={clsx(classes.bold)}> 31 - 45 days</span></div>
                    <Swiper
                        id="swiper-over_due_thirty_45"
                        slidesPerView={mobileDevice ? 2 : 1}
                        spaceBetween={mobileDevice ? 10 : 0}
                        slidesPerGroup={mobileDevice ? 2 : 1}
                        autoplay={{
                            delay: 5000,
                            pauseOnMouseEnter: true
                        }}
                        loop
                        onReachEnd={() => {
                        }}
                        pagination={false}>
                        {
                            salesDashboardDetails && salesDashboardDetails['over_due_30_45']?.length > 0 ? salesDashboardDetails['over_due_30_45']?.map((data, i) => (
                                <SwiperSlide key={`over_due_30_45-${i}`} style={{ listStyle: "none" }}>
                                    <div className={classes.daysRow} key={i}>
                                        <Link to={`/${type}/transactions/${AESEncrypt(data?.id)}/invoice-history`} className={clsx(classes.daysRowTitle, classes.bold, classes.overDuedaysRowTitle)}><span className={clsx(classes.bg_green_light)}><span>{i + 1}</span></span>{data.name}</Link>
                                        <div className={clsx(classes.daysRowContent, classes.bg_green_light)}>
                                            <div className={classes.daysRowContentInner}>
                                                <div className={classes.daysRowContentTitle}>No. of Invoices</div><div className={clsx(classes.daysRowText, classes.bold)}>{data.invoices}</div>
                                            </div>
                                            <div className={clsx(classes.daysRowContentInner, classes.daysRowContentInner, classes.textAlignRight)}>
                                                <div className={classes.daysRowContentTitle}>Balance (₹)</div><div className={clsx(classes.daysRowText, classes.bold)}>{currencyFormat(data.balance)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )) : 'No Overdues'
                        }
                    </Swiper>
                </div>
                <div className={clsx(classes.chartOverDueContent)}>
                    <div className={clsx(classes.bold, classes.dueDate)}><span>Due Date Greater than</span>
                        <span className={clsx(classes.bold)}> 45 days</span></div>
                    <Swiper
                        id="swiper-over_due_more_45"
                        slidesPerView={mobileDevice ? 2 : 1}
                        spaceBetween={mobileDevice ? 10 : 0}
                        slidesPerGroup={mobileDevice ? 2 : 1}
                        autoplay={{
                            delay: 5000,
                            pauseOnMouseEnter: true
                        }}
                        loop
                        onReachEnd={() => {
                        }}
                        pagination={false}>
                        {
                            salesDashboardDetails && salesDashboardDetails['over_due_more_45']?.length > 0 ? salesDashboardDetails['over_due_more_45']?.map((data, i) => (
                                <SwiperSlide key={`slide-${i}`} style={{ listStyle: "none" }}>
                                    <div className={classes.daysRow} key={i}>
                                        <Link to={`/${type}/transactions/${AESEncrypt(data?.id)}/invoice-history`} className={clsx(classes.daysRowTitle, classes.bold, classes.overDuedaysRowTitle)}><span className={clsx(classes.bg_gray_light)}><span>{i + 1}</span></span>{data.name}</Link>
                                        <div className={clsx(classes.daysRowContent, classes.bg_gray_light)}>
                                            <div className={classes.daysRowContentInner}>
                                                <div className={classes.daysRowContentTitle}>No. of Invoices</div><div className={clsx(classes.daysRowText, classes.bold)}>{data.invoices}</div>
                                            </div>
                                            <div className={clsx(classes.daysRowContentInner, classes.daysRowContentInner, classes.textAlignRight)}>
                                                <div className={classes.daysRowContentTitle}>Balance (₹)</div><div className={clsx(classes.daysRowText, classes.bold)}>{currencyFormat(data.balance)}</div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )) : 'No Overdues'
                        }
                    </Swiper>
                </div>
            </div>
        </div >
    )
}